export const AVATARS = [
  { id: 'wolf', label: 'Kurt' },
  { id: 'fox', label: 'Tilki' },
  { id: 'lion', label: 'Aslan' },
  { id: 'panther', label: 'Panter' },
  { id: 'hawk', label: 'Şahin' },
  { id: 'dragon', label: 'Ejder' },
  { id: 'ninja', label: 'Ninja' },
  { id: 'cyber', label: 'Siber' },
];

export const DEFAULT_AVATAR = AVATARS[0].id;

export const avatarSrc = (id) => {
  const key = AVATARS.some((a) => a.id === id) ? id : DEFAULT_AVATAR;
  return `/icons3d/avatars/${key}.png`;
};
